export const FETCH_RESOURCE = '[ Resource ] Fetch resource'
export const FETCH_RESOURCES = '[ Resource ] Fetch resources'

export const CLEAR_RESOURCE = '[ Resource ] Clear resource state'
export const CREATE_RESOURCE = '[ Resource ] Create resource'
export const RESTORE_RESOURCE = '[ Resource ] Restore resource'
export const UPDATE_RESOURCE = '[ Resource ] Update resource'

export const REMOVE_RESOURCE = '[ Resource ] Remove resource'
export const REMOVE_RESOURCE__FAILED = `[ Resource ] Couldn't remove resource`
export const REMOVE_RESOURCE__HIDE = '[ Resource ] Hide resource (currently removing)'

export const CREATE_RESOURCE_VARIANT = '[ Resource ] Create resource variant'
export const RESTORE_RESOURCE_VARIANT = '[ Resource ] Restore resource variant'

export const REMOVE_RESOURCE_VARIANT = '[ Resource ] Remove resource variant'
export const REMOVE_RESOURCE_VARIANT__FAILED = `[ Resource ] Couldn't remove resource variant`
export const REMOVE_RESOURCE_VARIANT__HIDE =
  '[ Resource ] Hide resource variant (currently removing)'

export const TEMPORARY_RESOURCE__CREATE = '[ Resource ] Create temporary resource'
export const TEMPORARY_RESOURCE__CREATE_VARIANT = '[ Resource ] Create temporary resource variant'
export const TEMPORARY_RESOURCE__REMOVE = '[ Resource ] Remove temporary resource'
export const TEMPORARY_RESOURCE__REMOVE_VARIANT = '[ Resource ] Remove temporary resource variant'
